const SELECTORS = {
  checkbox: 'marketing-checkbox-wrapper',

  // Checkbox disclaimer accanto all'input
  defaultDisclaimer: 'default-disclaimer-text',
  usDisclaimer: 'us-disclaimer-text',
  caDisclaimer: 'ca-disclaimer-text',
  emeaDisclaimer: 'emea-disclaimer-text',

  // Testo policy nella modale
  policyDefault: 'policy-text-default',
  policyUS: 'policy-text-us',
  policyCA: 'policy-text-ca',
  policyEMEA: 'policy-text-emea',

  // Area personale → testo accanto alla checkbox
  marketingDefault: 'marketing-checkbox-text-default',
  marketingUS: 'marketing-checkbox-text-us',
  marketingCA: 'marketing-checkbox-text-ca',
  marketingEMEA: 'marketing-checkbox-text-emea',

  // SMS marketing checkbox text
  smsMarketingDefault: 'sms-marketing-checkbox-text-default',
  smsMarketingUS: 'sms-marketing-checkbox-text-us',
  smsMarketingCA: 'sms-marketing-checkbox-text-ca',
  smsMarketingEMEA: 'sms-marketing-checkbox-text-emea'
};

const EMEA_COUNTRIES = [
  // UNIONE EUROPEA (27 stati)
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU',
  'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',

  // MEDIO ORIENTE / MENA
  'AE', 'BH', 'EG', 'IL', 'IQ', 'IR', 'JO', 'KW', 'LB', 'OM', 'PS', 'QA',
  'SA', 'SY', 'TR', 'YE',

  // AFRICA (tutti i 54 stati sovrani)
  'DZ', 'AO', 'BJ', 'BW', 'BF', 'BI', 'CV', 'CM', 'CF', 'TD', 'KM', 'CD',
  'CG', 'CI', 'DJ', 'EG', 'GQ', 'ER', 'SZ', 'ET', 'GA', 'GM', 'GH', 'GN',
  'GW', 'KE', 'LS', 'LR', 'LY', 'MG', 'MW', 'ML', 'MR', 'MU', 'MA', 'MZ',
  'NA', 'NE', 'NG', 'RW', 'ST', 'SN', 'SC', 'SL', 'SO', 'ZA', 'SS', 'SD',
  'TZ', 'TG', 'TN', 'UG', 'ZM', 'ZW'
];

/**
 * Determina la regione in base alle localizzazioni di Shopify
 * @returns {String} La regione rilevata (US, CA, EMEA o DEFAULT)
 */
function detectRegionFromShopifyLocales() {
  // Verifica se le informazioni sulle localizzazioni sono già disponibili
  if (window.PERSOL_STORE_REGION) {
    //console.log('[GeoDisclaimers] Regione rilevata da Shopify:', window.PERSOL_STORE_REGION);
    return window.PERSOL_STORE_REGION;
  }
  
  // Verifica se è disponibile la mappatura root_url
  if (window.PERSOL_ROOT_URL_MAPPINGS) {
    const currentPath = window.location.pathname;
    // Log per debug
    //console.log('[GeoDisclaimers] Analisi path corrente:', currentPath);
    
    // Cerca nella mappatura il prefisso che corrisponde al path corrente
    for (const [rootUrl, region] of Object.entries(window.PERSOL_ROOT_URL_MAPPINGS)) {
      if (currentPath.startsWith(rootUrl)) {
        //console.log('[GeoDisclaimers] Path match trovato:', rootUrl, '→', region);
        return region;
      }
    }
    
    //console.log('[GeoDisclaimers] Nessun match trovato nella mappatura rootUrl, provo con il locale corrente');
  }
  
  // Fallback: prova a utilizzare il codice ISO
  if (window.SHOP_LOCALES && window.SHOP_LOCALES.current) {
    const isoCode = window.SHOP_LOCALES.current.iso_code;
    if (isoCode) {
      const parts = isoCode.split('-');
      if (parts.length >= 2) {
        const country = parts[1].toUpperCase();
        
        if (country === 'US') {
          return 'US';
        } else if (country === 'CA') {
          return 'CA';
        } else if (EMEA_COUNTRIES.includes(country)) {
          return 'EMEA';
        }
      }
    }
  }
  
  // Se non riusciamo a determinare la regione, ritorna DEFAULT
  console.log('[GeoDisclaimers] Impossibile determinare la regione, utilizzando DEFAULT');
  return 'DEFAULT';
}

function initGeoDisclaimers() {
  //console.log('[GeoDisclaimers] Inizializzazione...');
  
  // Log per vedere le informazioni di localizzazione disponibili
  //console.log('[GeoDisclaimers] Shopify Locales:', window.SHOP_LOCALES || 'non disponibile');
  //console.log('[GeoDisclaimers] Root URL mappings:', window.PERSOL_ROOT_URL_MAPPINGS || 'non disponibile');
  //console.log('[GeoDisclaimers] Path corrente:', window.location.pathname);
  
  // Verifica la presenza dei nostri elementi specifici per i disclaimer
  const defaultEl = document.getElementById(SELECTORS.defaultDisclaimer);
  const usEl = document.getElementById(SELECTORS.usDisclaimer);
  const caEl = document.getElementById(SELECTORS.caDisclaimer);
  const emeaEl = document.getElementById(SELECTORS.emeaDisclaimer);
  
  /* console.log('[GeoDisclaimers] Elementi disclaimer trovati:', {
    defaultDisclaimer: defaultEl ? 'presente' : 'non trovato',
    usDisclaimer: usEl ? 'presente' : 'non trovato',
    caDisclaimer: caEl ? 'presente' : 'non trovato',
    emeaDisclaimer: emeaEl ? 'presente' : 'non trovato'
  }); */
  
  // Verifica se ci sono elementi da gestire
  if (!defaultEl && !usEl && !caEl && !emeaEl) {
    return; // Esci se non ci sono elementi disclaimer da gestire
  }
  
  // Determina la regione dalle localizzazioni di Shopify
  const region = detectRegionFromShopifyLocales();
  //console.log('[GeoDisclaimers] Regione rilevata:', region);
  
  if (region !== 'DEFAULT') {
    //console.log('[GeoDisclaimers] Applicando la logica per la regione:', region);
    
    if (region === 'US') {
      //console.log('[GeoDisclaimers] Regione US rilevata, applico logica US');
      toggleDisclaimers('US');
    } else if (region === 'CA') {
      //console.log('[GeoDisclaimers] Regione CA rilevata, applico logica CA');
      toggleDisclaimers('CA');
    } else if (region === 'EMEA') {
      //console.log('[GeoDisclaimers] Regione EMEA rilevata, applico logica EMEA');
      toggleDisclaimers('EMEA');
    }
  } else {
    // Per le regioni non specifiche (non US, non CA, non EMEA)
    //console.log('[GeoDisclaimers] Regione DEFAULT rilevata, mostro il disclaimer predefinito');
    toggleDisclaimers('DEFAULT'); // Passiamo DEFAULT per indicare che va mostrato il disclaimer predefinito
  }
}

function detectCountry() {
  // Prima tenta con l'API di Shopify
  return fetch('/browsing_context_suggestions.json')
    .then(res => {
      if (!res.ok) {
        throw new Error('Errore nel recupero dati da browsing_context_suggestions.json');
      }
      return res.json();
    })
    .then(data => {
      const countryCode = data?.detected_values?.country?.handle;
      if (!countryCode) {
        throw new Error('Nessun codice paese trovato nei dati di Shopify');
      }
      return countryCode;
    })
    .catch(err => {
      console.warn('[GeoDisclaimers] Fallback su ipapi:', err.message);
      
      // Fallback su ipapi.co
      return fetch('https://ipapi.co/json/')
        .then(res => {
          if (!res.ok) {
            throw new Error('Errore nel recupero dati da ipapi.co');
          }
          return res.json();
        })
        .then(ipdata => {
          const countryCode = ipdata?.country;
          if (!countryCode) {
            throw new Error('Nessun codice paese trovato nei dati di ipapi');
          }
          return countryCode;
        })
        .catch(err => {
          console.error('[GeoDisclaimers] Impossibile rilevare il paese:', err.message);
          return null; // Ritorna null in caso di errore per gestirlo in handleCountryContent
        });
    });
}

function handleCountryContent(code) {
  //console.log('[GeoDisclaimers] handleCountryContent chiamato con codice paese:', code);
  
  const isUS = code === 'US';
  const isCA = code === 'CA';
  const isEMEA = EMEA_COUNTRIES.includes(code);

  if (isUS) {
    //console.log('[GeoDisclaimers] Applicando logica US');
    toggleDisclaimers('US');
    togglePolicyText('US');
    toggleMarketingText('US');
    toggleSmsMarketingText('US');
  } else if (isCA) {
    //console.log('[GeoDisclaimers] Applicando logica CA');
    toggleDisclaimers('CA');
    togglePolicyText('CA');
    toggleMarketingText('CA');
    toggleSmsMarketingText('CA');
  } else if (isEMEA) {
    //console.log('[GeoDisclaimers] Applicando logica EMEA');
    toggleDisclaimers('EMEA');
    togglePolicyText('EMEA');
    toggleMarketingText('EMEA');
    toggleSmsMarketingText('EMEA');
  } else {
    //console.log('[GeoDisclaimers] Regione non specifica (non US/CA/EMEA), mostro contenuti predefiniti');
    toggleDisclaimers('DEFAULT');
    togglePolicyText('DEFAULT');
    toggleMarketingText('DEFAULT');
    toggleSmsMarketingText('DEFAULT');
  }
}

function toggleDisclaimers(region) {
  // Ottieni riferimenti ai contenitori dei disclaimer
  const defaultEl = document.getElementById(SELECTORS.defaultDisclaimer);
  const usEl = document.getElementById(SELECTORS.usDisclaimer);
  const caEl = document.getElementById(SELECTORS.caDisclaimer);
  const emeaEl = document.getElementById(SELECTORS.emeaDisclaimer);

  //console.log('[GeoDisclaimers] toggleDisclaimers chiamato con regione:', region);
  /* console.log('[GeoDisclaimers] Elementi trovati:', {
    defaultEl: defaultEl ? 'presente' : 'non trovato',
    usEl: usEl ? 'presente' : 'non trovato',
    caEl: caEl ? 'presente' : 'non trovato',
    emeaEl: emeaEl ? 'presente' : 'non trovato'
  }); */

  if (!defaultEl && !usEl && !caEl && !emeaEl) {
    console.log('[GeoDisclaimers] Nessun elemento disclaimer trovato nella pagina');
    return;
  }

  // Nascondi prima tutti i disclaimer
  if (defaultEl) defaultEl.style.display = 'none';
  if (usEl) usEl.style.display = 'none';
  if (caEl) caEl.style.display = 'none';
  if (emeaEl) emeaEl.style.display = 'none';

  // Mostra solo il disclaimer appropriato in base alla regione
  if (region === 'US' && usEl) {
    //console.log('[GeoDisclaimers] Mostro disclaimer US');
    usEl.style.display = 'block';
  } else if (region === 'CA' && caEl) {
    //console.log('[GeoDisclaimers] Mostro disclaimer CA');
    caEl.style.display = 'block';
  } else if (region === 'EMEA' && emeaEl) {
    //console.log('[GeoDisclaimers] Mostro disclaimer EMEA');
    emeaEl.style.display = 'block';
  } else {
    // Per tutte le altre regioni o se il disclaimer specifico manca
    //console.log('[GeoDisclaimers] Mostro disclaimer predefinito');
    if (defaultEl) defaultEl.style.display = 'block';
  }
}

function togglePolicyText(region) {
  const defaultEl = document.getElementById(SELECTORS.policyDefault);
  const usEl = document.getElementById(SELECTORS.policyUS);
  const caEl = document.getElementById(SELECTORS.policyCA);
  const emeaEl = document.getElementById(SELECTORS.policyEMEA);

  if (!defaultEl && !usEl && !caEl && !emeaEl) {
    console.log('[GeoDisclaimers] Nessun elemento policy text trovato nella pagina');
    return;
  }

  // Nascondi prima tutti
  if (defaultEl) defaultEl.style.display = 'none';
  if (usEl) usEl.style.display = 'none';
  if (caEl) caEl.style.display = 'none';
  if (emeaEl) emeaEl.style.display = 'none';
  
  // Mostra solo quello appropriato
  if (region === 'US' && usEl) {
    if (usEl.innerHTML.trim() !== '') {
      usEl.style.display = 'block';
    } else if (defaultEl) {
      defaultEl.style.display = 'block'; // Fallback al default
    }
  } else if (region === 'CA' && caEl) {
    if (caEl.innerHTML.trim() !== '') {
      caEl.style.display = 'block';
    } else if (defaultEl) {
      defaultEl.style.display = 'block'; // Fallback al default
    }
  } else if (region === 'EMEA' && emeaEl) {
    if (emeaEl.innerHTML.trim() !== '') {
      emeaEl.style.display = 'block';
    } else if (defaultEl) {
      defaultEl.style.display = 'block'; // Fallback al default
    }
  } else if (defaultEl) {
    defaultEl.style.display = 'block';
  }
}

function toggleMarketingText(region) {
  const defaultEl = document.getElementById(SELECTORS.marketingDefault);
  const usEl = document.getElementById(SELECTORS.marketingUS);
  const caEl = document.getElementById(SELECTORS.marketingCA);
  const emeaEl = document.getElementById(SELECTORS.marketingEMEA);

  if (!defaultEl && !usEl && !caEl && !emeaEl) {
    console.log('[GeoDisclaimers] Nessun elemento marketing text trovato nella pagina');
    return;
  }

  // Nascondi prima tutti
  if (defaultEl) defaultEl.style.display = 'none';
  if (usEl) usEl.style.display = 'none';
  if (caEl) caEl.style.display = 'none';
  if (emeaEl) emeaEl.style.display = 'none';

  if (region === 'US' && usEl) {
    //console.log('[GeoDisclaimers] Marketing text: mostro versione US');
    if (usEl.innerText.trim() !== '') {
      usEl.style.display = 'block';
    } else if (defaultEl) {
      defaultEl.style.display = 'block'; // Fallback al default
    }
  } else if (region === 'CA' && caEl) {
    //console.log('[GeoDisclaimers] Marketing text: mostro versione CA');
    if (caEl.innerText.trim() !== '') {
      caEl.style.display = 'block';
    } else if (defaultEl) {
      defaultEl.style.display = 'block'; // Fallback al default
    }
  } else if (region === 'EMEA' && emeaEl) {
    //console.log('[GeoDisclaimers] Marketing text: mostro versione EMEA');
    if (emeaEl.innerText.trim() !== '') {
      emeaEl.style.display = 'block';
    } else if (defaultEl) {
      defaultEl.style.display = 'block'; // Fallback al default
    }
  } else if (defaultEl) {
    //console.log('[GeoDisclaimers] Marketing text: mostro versione predefinita');
    defaultEl.style.display = 'block';
  }
}

function toggleSmsMarketingText(region) {
  const defaultEl = document.getElementById(SELECTORS.smsMarketingDefault);
  const usEl = document.getElementById(SELECTORS.smsMarketingUS);
  const caEl = document.getElementById(SELECTORS.smsMarketingCA);
  const emeaEl = document.getElementById(SELECTORS.smsMarketingEMEA);

  if (!defaultEl && !usEl && !caEl && !emeaEl) {
    console.log('[GeoDisclaimers] Nessun elemento SMS marketing text trovato nella pagina');
    return;
  }

  // Nascondi prima tutti
  if (defaultEl) defaultEl.style.display = 'none';
  if (usEl) usEl.style.display = 'none';
  if (caEl) caEl.style.display = 'none';
  if (emeaEl) emeaEl.style.display = 'none';

  if (region === 'US' && usEl) {
    //console.log('[GeoDisclaimers] SMS Marketing text: mostro versione US');
    if (usEl.innerText.trim() !== '') {
      usEl.style.display = 'block';
    } else if (defaultEl) {
      defaultEl.style.display = 'block'; // Fallback al default
    }
  } else if (region === 'CA' && caEl) {
    //console.log('[GeoDisclaimers] SMS Marketing text: mostro versione CA');
    if (caEl.innerText.trim() !== '') {
      caEl.style.display = 'block';
    } else if (defaultEl) {
      defaultEl.style.display = 'block'; // Fallback al default
    }
  } else if (region === 'EMEA' && emeaEl) {
    //console.log('[GeoDisclaimers] SMS Marketing text: mostro versione EMEA');
    if (emeaEl.innerText.trim() !== '') {
      emeaEl.style.display = 'block';
    } else if (defaultEl) {
      defaultEl.style.display = 'block'; // Fallback al default
    }
  } else if (defaultEl) {
    //console.log('[GeoDisclaimers] SMS Marketing text: mostro versione predefinita');
    defaultEl.style.display = 'block';
  }
}

/**
 * Gestisce le checkbox nella sezione account (default unchecked).
 * Per US: nasconde solo l'input della checkbox email e la marca come checked.
 */
function manageAccountCheckboxes(region) {
  try {
    //console.log('[GeoDisclaimers] manageAccountCheckboxes chiamata con regione:', region);
    const cb1 = document.getElementById('marketing-checkbox-input-1');
    const cb2 = document.getElementById('marketing-checkbox-input-2');
    
    // Verifica se questo è un nuovo account (prima visita dopo registrazione)
    const isNewAccount = localStorage.getItem('is-account-new') === 'true';
    const savedPreference = localStorage.getItem('user_marketing_preference');
    
    // Per la regione US
    if (region === 'US') {
      //console.log('[GeoDisclaimers] Regione US: gestione speciale della checkbox');
      // Per US: checkbox SMS NON pre-selezionata - rispetta il consenso salvato
      if (cb1) {
        // Non modificare lo stato: il valore viene già da customer.metafields.custom.sms_consent nel template
        cb1.style.display = ''; // Rimuovi eventuali display:none
      }
      // Per US: checkbox email visibile, ma senza forzare lo stato.
      // Lo stato deve riflettere sempre customer.accepts_marketing renderizzato dal template.
      if (cb2) {
        cb2.style.display = ''; // Rimuovi eventuali display:none
        cb2.removeAttribute('aria-hidden');
      }
    } 
    // Per altre regioni, rispettiamo la preferenza dell'utente
    else {
      // Non modificare lo stato della checkbox per regioni non-US
      // Lo stato è già correttamente impostato da customer.accepts_marketing nel template
      //console.log('[GeoDisclaimers] Regione non-US:', region);
      
      // Solo per debug
/*       if (cb2) {
        console.log('[GeoDisclaimers] Stato attuale checkbox:', cb2.checked);
      } */
    }
    
    // Nuovi utenti con preferenza esplicita (per regioni non-US)
    if (isNewAccount && savedPreference !== null && region !== 'US' && cb2) {
      // Questa logica è ora gestita dallo script inline in po-account-summary.liquid
      console.log('[GeoDisclaimers] Nuovo utente rilevato, la preferenza verrà gestita dallo script dedicato');
    }
  } catch (e) {
    console.warn('[GeoDisclaimers] Errore in manageAccountCheckboxes:', e);
  }
}

/**
 * Funzione per inizializzare i geo disclaimers nelle newsletter
 * Questa funzione viene esposta globalmente per essere chiamata quando necessario
 */
window.initNewsletterGeoPolicy = function() {
  //console.log('[GeoDisclaimers] Inizializzazione policy newsletter...');
  
  // Determina la regione
  const region = detectRegionFromShopifyLocales();
  //console.log('[GeoDisclaimers] Regione rilevata per newsletter:', region);
  
  // Applica la policy text appropriata
  if (region === 'US') {
    togglePolicyText('US');
  } else if (region === 'CA') {
    togglePolicyText('CA');
  } else if (region === 'EMEA') {
    togglePolicyText('EMEA');
  } else {
    togglePolicyText('DEFAULT');
  }
};

/**
 * Osserva l'apertura dell'overlay della newsletter
 */
function setupNewsletterOverlayObserver() {
  const overlay = document.querySelector('.tw-po-newsletter-overlay');
  if (overlay) {
    //console.log('[GeoDisclaimers] Configuro observer per newsletter overlay');
    
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.attributeName === 'class' && overlay.classList.contains('open')) {
          //console.log('[GeoDisclaimers] Overlay newsletter aperto, applico geo policy');
          window.initNewsletterGeoPolicy();
        }
      });
    });
    
    // Osserva i cambiamenti di classe sull'overlay
    observer.observe(overlay, { attributes: true, attributeFilter: ['class'] });
  }
}

// Attendi che il DOM sia completamente caricato
document.addEventListener('DOMContentLoaded', function() {
  //console.log('[GeoDisclaimers] DOM caricato, avvio script');
  
  // Ritardo l'inizializzazione per assicurarsi che tutti gli elementi siano disponibili
  setTimeout(function() {
    initGeoDisclaimers();
    setupNewsletterOverlayObserver();
    // Chiamiamo subito in caso l'overlay sia già aperto
    window.initNewsletterGeoPolicy();
    // Applichiamo le regole per le checkbox della sezione account
    const region = detectRegionFromShopifyLocales();
    manageAccountCheckboxes(region);
  }, 100);
});
